// Scanner utilities for top-level segment parsing in incremental mode.
// Keeps segment-key and whitespace helpers isolated for reuse and size control.
import type { LuisScannedSegment } from './types'

// Push trimmed non-empty segment text with stable key metadata.
export function pushSegment(
  segments: LuisScannedSegment[],
  kind: LuisScannedSegment['kind'],
  content: string,
  line: number,
): void {
  const trimmed = content.trim()
  // Skip empty segment buffers produced by whitespace.
  if (!trimmed) {
    return
  } else {
    // Continue stable key generation for non-empty segments.
  }

  segments.push({
    kind,
    content: trimmed,
    line,
    key: `${kind}:${segments.length}`,
  })
}

// Detect whitespace-only segment buffer before first token appears.
export function isSegmentWhitespaceOnly(input: string): boolean {
  // Return true when segment buffer has no non-whitespace char.
  return input.trim().length === 0
}

// Detect scanner-recognized whitespace tokens.
export function isWhitespace(char: string): boolean {
  // Return true for scanner whitespace chars.
  return char === ' ' || char === '\t' || char === '\n' || char === '\r'
}
